import styled from 'styled-components';
import { BUTTON_VARIANTS } from 'ui/button';
import { LinkButton } from 'ui/linkButton';
import { spacing } from 'ui/theme';
import { ContentType } from './utils';

type AlertHistoryFooterProps = {
  buttonContent: ContentType;
};

const SlideOverButtonWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${spacing.half};
  width: 100%;
  && > button {
    flex-grow: 1;
  }
`;

const StyledLinkButton = styled(LinkButton)`
  display: flex;
  flex: 1;
  justify-content: center;
  gap: ${spacing.half};
`;

export const AlertHistoryFooter = ({ buttonContent }: AlertHistoryFooterProps) => (
  <SlideOverButtonWrapper>
    <StyledLinkButton
      to={buttonContent?.route}
      variant={BUTTON_VARIANTS.SECONDARY}
      data-test={'alert-history-button-content'}
    >
      {buttonContent?.label}
    </StyledLinkButton>
  </SlideOverButtonWrapper>
);
